/* Progressive enhancements: without JavaScript, rails scroll and descriptions remain readable. */
if (!customElements.get('topic-rail-ak')) {
  customElements.define('topic-rail-ak', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-topic-list]');
      this.buttons = Array.from(this.querySelectorAll('[data-direction]'));
      this.onClick = (event) => {
        const button = event.target.closest('[data-direction]');
        if (!button || !this.contains(button)) return;
        const card = this.list.querySelector('li');
        const step = (card?.getBoundingClientRect().width || 240) + 12;
        this.list.scrollBy({ left: Number(button.dataset.direction) * step,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.update = () => {
        const max = this.list.scrollWidth - this.list.clientWidth;
        this.buttons.forEach((button) => {
          // Keep the focused control in the tab sequence when it reaches the end.
          button.setAttribute('aria-disabled', String(Number(button.dataset.direction) < 0
            ? this.list.scrollLeft <= 1 : this.list.scrollLeft >= max - 1));
          button.hidden = max < 2;
        });
      };
      this.addEventListener('click', this.onClick);
      this.list.addEventListener('scroll', this.update, { passive: true });
      this.resizer = new ResizeObserver(this.update);
      this.resizer.observe(this.list);
      this.update();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.list?.removeEventListener('scroll', this.update);
      this.resizer?.disconnect();
    }
  });
}

if (!customElements.get('description-ak')) {
  customElements.define('description-ak', class extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-description-content]');
      this.button = this.querySelector('button');
      if (!this.content || !this.button) return;
      this.onClick = () => {
        const expanded = this.button.getAttribute('aria-expanded') !== 'true';
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.textContent = expanded ? 'Read less' : 'Read more';
        this.classList.toggle('is-clamped', !expanded);
      };
      this.button.addEventListener('click', this.onClick);
      // A height clamp preserves any rich product markup and leaves short descriptions alone.
      this.measure = () => {
        if (this.button.getAttribute('aria-expanded') === 'true') return;
        const lineHeight = parseFloat(getComputedStyle(this.content).lineHeight) || 24;
        const limit = lineHeight * 3;
        this.style.setProperty('--ak-description-height', `${limit}px`);
        this.classList.toggle('is-clamped', this.content.scrollHeight > limit + 4);
        this.button.hidden = this.content.scrollHeight <= limit + 4;
        // A focused link or control in the copy must never be clipped out of sight.
      };
      this.onFocus = (event) => {
        if (this.content.contains(event.target) && this.classList.contains('is-clamped')) this.button.click();
      };
      this.content.addEventListener('focusin', this.onFocus);
      this.resizer = new ResizeObserver(this.measure);
      this.resizer.observe(this.content);
      this.measure();
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.content?.removeEventListener('focusin', this.onFocus);
      this.resizer?.disconnect();
    }
  });
}

// A color change shows that color's photos, which sit hidden and lazy until then, so the gallery went blank
// for seconds on the first switch. After load, fetch them all so the switch paints from cache.
// ponytail: loads every gallery image (about 12 per product); limit to each color's first photo if pages get heavy.
window.addEventListener('load', () => {
  for (const img of document.querySelectorAll('media-gallery img[loading="lazy"]')) img.loading = 'eager';
});
